module.exports = "/_next/static/images/placeholder-counterparty-logo-0f4d3cd3e9a0d3b875687ac00693c7d5.png";